import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Sidebar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const SidebarHeader: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['header'], className)}>
        {children}
    </div>
);

SidebarHeader.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

SidebarHeader.defaultProps = {
    className: undefined,
    children: undefined
};

export default SidebarHeader;
